import { isFixedIncome, isOption, optionsContractMultiplier } from '@shared/helpers';
import { CostBasisPosition } from '@shared/services';

import { math } from '../src/app/shared/helpers/mathjs/mathjs';
import { toNumber } from './utils.helpers';

type EstimatedTotalTransferValueInput = Pick<CostBasisPosition, 'estValueOfTransfer'>;

export function getEstimatedTotalTransferValue(
  positions: EstimatedTotalTransferValueInput[],
): number {
  const total: number = positions.reduce(
    (accumulated, position) => math.add(accumulated, toNumber(position.estValueOfTransfer)),
    0,
  );
  return total;
}

type EstimatedTotalTransferValueBySharesInput = Pick<
  CostBasisPosition,
  'price' | 'estValueOfTransfer' | 'sharesToTransfer' | 'securityType'
>;

export function getEstimatedValueOfTransferByShares<
  T extends EstimatedTotalTransferValueBySharesInput,
>(position: T, multiItMoToggleEnabled = false): T {
  const newPosition: T = { ...position };

  let price = toNumber(newPosition.price);
  if (isFixedIncome(position.securityType)) {
    price /= 100;
  } else if (multiItMoToggleEnabled && isOption(position.securityType)) {
    price *= optionsContractMultiplier;
  }

  newPosition.estValueOfTransfer = +math.format(
    math.multiply(toNumber(newPosition.sharesToTransfer), price),
    { notation: 'fixed', precision: 2 },
  );
  return newPosition;
}
